import React, { useRef, useEffect } from "react";

interface GazeHeatmapCanvasProps {
  imageData: ImageData | null;
  opacity?: number;
  className?: string;
}

/**
 * Canvas component to render the heatmap overlay
 */
const GazeHeatmapCanvas: React.FC<GazeHeatmapCanvasProps> = ({
  imageData,
  opacity = 1.0,
  className = "",
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !imageData) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Set canvas size to match image data
    canvas.width = imageData.width;
    canvas.height = imageData.height;

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw heatmap
    ctx.putImageData(imageData, 0, 0);
  }, [imageData]);

  if (!imageData) return null;

  return (
    <canvas
      ref={canvasRef}
      className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
      style={{ opacity }}
    />
  );
};

export default GazeHeatmapCanvas;
